import {
  AuthConfig,
  initializeApollo
} from '@mono/packages/graphql/apollo/apollo'
import { GraphqlApi } from '@mono/packages/graphql/apollo/constants'
import { translateActiveLocale } from '@utils/i18n'
import { getFailureMessage } from '@utils/mutationResults'
import { useMemo } from 'react'
import { cache } from './cache'
import { showFailureToast } from './variables/toastState'

export function useApollo(
  defaultApiContext: GraphqlApi,
  authConfig: AuthConfig,
  initialState?: any
) {
  const store = useMemo(
    () =>
      initializeApollo(initialState, {
        defaultApiContext,
        authConfig,
        cache,
        showErrorToast: showFailureToast,
        translate: translateActiveLocale,
        getBusinessFailureMessage: getFailureMessage
      }),
    [defaultApiContext, initialState, authConfig]
  )
  return store
}
